import {ErrorStateScheduleEnum} from '../error-state-schedule.enum';

export enum PanelAccountsAddCashResolverErrorStatesEnum {
    GetTradingGroupsFailed = ErrorStateScheduleEnum.PanelAccountsAddCashResolverStatesStartIndex,
    ActiveTradingGroupsNotFound,
    GetPortalsForTenantFailed,
    GetPortalsForTenantInvalidData,
    GetAvailablePortalsFailed,
    AvailablePortalsNotFound,
    GetCurrenciesNotFound
}
